"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcInputInterceptorConstants = void 0;
var bc_input_constants_1 = require("./bc-input-constants");
var bc_input_constants_2 = require("./bc-input-constants");
var bc_input_constants_3 = require("./bc-input-constants");
var bc_input_constants_4 = require("./bc-input-constants");
var bc_input_constants_5 = require("./bc-input-constants");
var bc_input_constants_6 = require("./bc-input-constants");
var bc_input_constants_7 = require("./bc-input-constants");
var bc_input_constants_8 = require("./bc-input-constants");
var bc_input_constants_9 = require("./bc-input-constants");
var bc_input_constants_10 = require("./bc-input-constants");
var bc_input_constants_11 = require("./bc-input-constants");
var bc_input_constants_12 = require("./bc-input-constants");
var bc_input_constants_13 = require("./bc-input-constants");
var bc_input_constants_14 = require("./bc-input-constants");
var bc_input_constants_15 = require("./bc-input-constants");
var bc_input_constants_16 = require("./bc-input-constants");
var bc_input_constants_17 = require("./bc-input-constants");
var bc_input_constants_18 = require("./bc-input-constants");
var bc_input_constants_19 = require("./bc-input-constants");
var bc_input_constants_20 = require("./bc-input-constants");
var bc_input_constants_21 = require("./bc-input-constants");
var bc_input_constants_22 = require("./bc-input-constants");
var bc_input_constants_23 = require("./bc-input-constants");
var bc_input_constants_24 = require("./bc-input-constants");
var bc_input_constants_25 = require("./bc-input-constants");
var bc_input_constants_26 = require("./bc-input-constants");
var bc_input_constants_27 = require("./bc-input-constants");
var bc_input_constants_28 = require("./bc-input-constants");
var bc_input_constants_29 = require("./bc-input-constants");
var bc_input_constants_30 = require("./bc-input-constants");
var bc_input_constants_31 = require("./bc-input-constants");
var bc_input_constants_32 = require("./bc-input-constants");
var bc_input_constants_33 = require("./bc-input-constants");
var bc_input_constants_34 = require("./bc-input-constants");
var bc_input_constants_35 = require("./bc-input-constants");
var bc_input_constants_36 = require("./bc-input-constants");
var bc_input_constants_37 = require("./bc-input-constants");
var bc_input_constants_38 = require("./bc-input-constants");
var bc_input_constants_39 = require("./bc-input-constants");
var bc_input_constants_40 = require("./bc-input-constants");
var bc_input_constants_41 = require("./bc-input-constants");
var bc_input_constants_42 = require("./bc-input-constants");
var bc_input_constants_43 = require("./bc-input-constants");
var bc_input_constants_44 = require("./bc-input-constants");
var bc_input_constants_45 = require("./bc-input-constants");
var bc_input_constants_46 = require("./bc-input-constants");
var bc_input_constants_47 = require("./bc-input-constants");
var bc_input_constants_48 = require("./bc-input-constants");
var bc_input_constants_49 = require("./bc-input-constants");
var bc_input_constants_50 = require("./bc-input-constants");
var bc_input_constants_51 = require("./bc-input-constants");
var bc_input_constants_52 = require("./bc-input-constants");
var bc_input_constants_53 = require("./bc-input-constants");
var bc_input_constants_54 = require("./bc-input-constants");
var bc_input_constants_55 = require("./bc-input-constants");
var bc_input_constants_56 = require("./bc-input-constants");
var bc_input_constants_57 = require("./bc-input-constants");
var bc_input_constants_58 = require("./bc-input-constants");
var BcInputInterceptorConstants = (function () {
    function BcInputInterceptorConstants() {
    }
    BcInputInterceptorConstants.INPUT_CLASS = bc_input_constants_1.INPUT_CLASS;
    BcInputInterceptorConstants.INPUT_ACTIVE_CLASS = bc_input_constants_2.INPUT_ACTIVE_CLASS;
    BcInputInterceptorConstants.INPUT_FORM_FILE = bc_input_constants_3.INPUT_FORM_FILE;
    BcInputInterceptorConstants.INPUT_PADDING_RIGHT_WHEN_ICON = bc_input_constants_4.INPUT_PADDING_RIGHT_WHEN_ICON;
    BcInputInterceptorConstants.INVISIBLE_CLASS = bc_input_constants_5.INVISIBLE_CLASS;
    BcInputInterceptorConstants.ILUSTRATION_CLASS = bc_input_constants_6.ILUSTRATION_CLASS;
    BcInputInterceptorConstants.IMG_M_CLASS = bc_input_constants_7.IMG_M_CLASS;
    BcInputInterceptorConstants.EM_TAG = bc_input_constants_8.EM_TAG;
    BcInputInterceptorConstants.IMG_TAG = bc_input_constants_9.IMG_TAG;
    BcInputInterceptorConstants.INPUT_ERROR_CLASS = bc_input_constants_10.INPUT_ERROR_CLASS;
    BcInputInterceptorConstants.INPUT_SUCCESS_CLASS = bc_input_constants_11.INPUT_SUCCESS_CLASS;
    BcInputInterceptorConstants.BC_INPUT_VALIDATION_CLASS = bc_input_constants_12.BC_INPUT_VALIDATION_CLASS;
    BcInputInterceptorConstants.BC_INPUT_PASSWORD_CLASS = bc_input_constants_13.BC_INPUT_PASSWORD_CLASS;
    BcInputInterceptorConstants.BC_INPUT_CREDIT_CARD = bc_input_constants_14.BC_INPUT_CREDIT_CARD;
    BcInputInterceptorConstants.BC_INPUT_VALUE_CLASS = bc_input_constants_15.BC_INPUT_VALUE_CLASS;
    BcInputInterceptorConstants.BC_INPUT_VALUE_INT_CLASS = bc_input_constants_16.BC_INPUT_VALUE_INT_CLASS;
    BcInputInterceptorConstants.INPUT_BUTTON_ICON_CLASS = bc_input_constants_17.INPUT_BUTTON_ICON_CLASS;
    BcInputInterceptorConstants.INPUT_SPAN_INFO = bc_input_constants_18.INPUT_SPAN_INFO;
    BcInputInterceptorConstants.INPUT_SPAN_INFO_COUNTER = bc_input_constants_19.INPUT_SPAN_INFO_COUNTER;
    BcInputInterceptorConstants.INPUT_COTAINER_COUNT = bc_input_constants_20.INPUT_COTAINER_COUNT;
    BcInputInterceptorConstants.INPUT_SPACE_COUNT = bc_input_constants_21.INPUT_SPACE_COUNT;
    BcInputInterceptorConstants.BC_INPUT_SUCCESSFUL_ICON = bc_input_constants_22.BC_INPUT_SUCCESSFUL_ICON;
    BcInputInterceptorConstants.BC_INPUT_REMOVE_ICON = bc_input_constants_23.BC_INPUT_REMOVE_ICON;
    BcInputInterceptorConstants.BC_CLOUDY_ICON = bc_input_constants_24.BC_CLOUDY_ICON;
    BcInputInterceptorConstants.BC_CARD_ICON = bc_input_constants_25.BC_CARD_ICON;
    BcInputInterceptorConstants.BC_ICON_NO_VIEW = bc_input_constants_26.BC_ICON_NO_VIEW;
    BcInputInterceptorConstants.BC_ICON_VIEW = bc_input_constants_27.BC_ICON_VIEW;
    BcInputInterceptorConstants.TYPE_ATR = bc_input_constants_28.TYPE_ATR;
    BcInputInterceptorConstants.TYPE_TEXT = bc_input_constants_29.TYPE_TEXT;
    BcInputInterceptorConstants.TYPE_PASSWORD = bc_input_constants_30.TYPE_PASSWORD;
    BcInputInterceptorConstants.FIRST_MSG_ERROR_ATR = bc_input_constants_31.FIRST_MSG_ERROR_ATR;
    BcInputInterceptorConstants.SECOND_MSG_ERROR_ATR = bc_input_constants_32.SECOND_MSG_ERROR_ATR;
    BcInputInterceptorConstants.HIRD_MSG_ERROR_ATR = bc_input_constants_33.HIRD_MSG_ERROR_ATR;
    BcInputInterceptorConstants.MSG_ERROR_VALUE_DEFAULT = bc_input_constants_34.MSG_ERROR_VALUE_DEFAULT;
    BcInputInterceptorConstants.MSG_ERROR_VALUE_DATE_DEFAULT = bc_input_constants_35.MSG_ERROR_VALUE_DATE_DEFAULT;
    BcInputInterceptorConstants.MSG_ERROR_VALUE_DATA_DEFAULT = bc_input_constants_36.MSG_ERROR_VALUE_DATA_DEFAULT;
    BcInputInterceptorConstants.NUMBER_1 = bc_input_constants_37.NUMBER_1;
    BcInputInterceptorConstants.NUMBER_2 = bc_input_constants_38.NUMBER_2;
    BcInputInterceptorConstants.NUMBER_5 = bc_input_constants_39.NUMBER_5;
    BcInputInterceptorConstants.NUMBER_100 = bc_input_constants_40.NUMBER_100;
    BcInputInterceptorConstants.NUMBER_12 = bc_input_constants_41.NUMBER_12;
    BcInputInterceptorConstants.ATTR_IS_INPUT_FRANCHISE = bc_input_constants_42.ATTR_IS_INPUT_FRANCHISE;
    BcInputInterceptorConstants.INPUT_CLASS_FRANCHISE = bc_input_constants_43.INPUT_CLASS_FRANCHISE;
    BcInputInterceptorConstants.ERROR_SPAN_CLASS = bc_input_constants_44.ERROR_SPAN_CLASS;
    BcInputInterceptorConstants.DATA_DISABLED = bc_input_constants_45.DATA_DISABLED;
    BcInputInterceptorConstants.TRUE = bc_input_constants_46.TRUE;
    BcInputInterceptorConstants.FALSE = bc_input_constants_47.FALSE;
    BcInputInterceptorConstants.ONWHEEL = bc_input_constants_48.ONWHEEL;
    BcInputInterceptorConstants.INPUT_TYPE_NUMBER = bc_input_constants_49.INPUT_TYPE_NUMBER;
    BcInputInterceptorConstants.RETURN = bc_input_constants_50.RETURN;
    BcInputInterceptorConstants.BC_INPUT_LABEL_PLACEHOLDER = bc_input_constants_51.BC_INPUT_LABEL_PLACEHOLDER;
    BcInputInterceptorConstants.COP = bc_input_constants_52.COP;
    BcInputInterceptorConstants.USD = bc_input_constants_53.USD;
    BcInputInterceptorConstants.EUR = bc_input_constants_54.EUR;
    BcInputInterceptorConstants.BC_DIVISA = bc_input_constants_55.BC_DIVISA;
    BcInputInterceptorConstants.BC_DIVISA_COP = bc_input_constants_56.BC_DIVISA_COP;
    BcInputInterceptorConstants.BC_DIVISA_USD = bc_input_constants_57.BC_DIVISA_USD;
    BcInputInterceptorConstants.BC_DIVISA_EUR = bc_input_constants_58.BC_DIVISA_EUR;
    return BcInputInterceptorConstants;
}());
exports.BcInputInterceptorConstants = BcInputInterceptorConstants;
